import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {UserAvailabilitySummaryResponseBody} from '@dms/api/shared';

import {AvailabilityStatus} from '../types/AvailabilityStatus';

export function getEffectiveAvailabilityStatus(
  summary: UserAvailabilitySummaryResponseBody | undefined
): AvailabilityStatus {
  if (isNil(summary)) {
    return 'available';
  }

  return match<UserAvailabilitySummaryResponseBody, AvailabilityStatus>(summary)
    .when(
      (value) => value.hasAbsence,
      () => 'absent'
    )
    .when(
      (value) => value.isAway,
      () => 'away'
    )
    .otherwise(() => 'available');
}
